/**
 * Rangefield
 * Purpose: provide JS smarts for the RangeField
 */
(function($){
  $(document).ready(function($) {

    $('input[type=range]').on('input', function() {
      var value = this.valueAsNumber;
      var max = $(this).attr('max');
      var max_means_all = $(this).attr('data-max-all');
      if(max_means_all && value >= max) {
        value = 'max';//_t()
      }
      // show current value for browsers not supporting it
      $('#' + this.id + '_display').html( value );
    });

  });
}(jQuery));
